module.exports = __webpack_public_path__ + "img/ShaderEditorHotReload.a2dfc799.gif";